/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_TitleInputs */



/**
* | output |
* | --- |
* | "Image Preview (Magnified)" |
*
* @param {Image_Export_Magnified_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_title = /** @type {((inputs?: Image_Export_Magnified_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualisation d'image (agrandie)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildvorschau (vergrößert)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima dell'immagine (ingrandita)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр изображения (увеличенное)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de la imagen (ampliada)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图片预览（放大）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像プレビュー（拡大）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छवि का पूर्वावलोकन (आवर्धित)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização da imagem (ampliada)")
	return /** @type {LocalizedString} */ ("Image Preview (Magnified)")
});